// extracted by mini-css-extract-plugin
export default {"base":"FluIndices_base__llXli","header":"FluIndices_header__6QEsU","content":"FluIndices_content__tide1","body":"FluIndices_body__UYDPR"};